import {CelestialBodyType, CelestialBody} from '../scene.model';

export const NAIAD: CelestialBody = {
  id: 'naiad',
  position: {
    x: 0,
    y: 0
  },
  mass: 19e15,
  radius: 30.2,
  semiMajorAxis: 48224,
  eccentricity: 0.0047,
  trueAnomaly: 0,
  meanAnomaly: 334.9,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const THALASSA: CelestialBody = {
  id: 'thalassa',
  position: {
    x: 0,
    y: 0
  },
  mass: 35e15,
  radius: 40.7,
  semiMajorAxis: 50074,
  eccentricity: 0.0018,
  trueAnomaly: 0,
  meanAnomaly: 193.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const DESPINA: CelestialBody = {
  id: 'despina',
  position: {
    x: 0,
    y: 0
  },
  mass: 220e15,
  radius: 78,
  semiMajorAxis: 52526,
  eccentricity: 0.0004,
  trueAnomaly: 0,
  meanAnomaly: 319.6,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const GALATEA: CelestialBody = {
  id: 'galatea',
  position: {
    x: 0,
    y: 0
  },
  mass: 212e15,
  radius: 87.4,
  semiMajorAxis: 61953,
  eccentricity: 0.0001,
  trueAnomaly: 0,
  meanAnomaly: 187.1,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const LARISSA: CelestialBody = {
  id: 'larissa',
  position: {
    x: 0,
    y: 0
  },
  mass: 420e15,
  radius: 97,
  semiMajorAxis: 73548,
  eccentricity: 0.0012,
  trueAnomaly: 0,
  meanAnomaly: 34.9,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HIPPOCAMP: CelestialBody = {
  id: 'hippocamp',
  position: {
    x: 0,
    y: 0
  },
  mass: 3e15,
  radius: 17.4,
  semiMajorAxis: 105283,
  eccentricity: 0.0005,
  trueAnomaly: 0,
  meanAnomaly: 0,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PROTEUS: CelestialBody = {
  id: 'proteus',
  position: {
    x: 0,
    y: 0
  },
  mass: 4400e15,
  radius: 210,
  semiMajorAxis: 117646,
  eccentricity: 0.0005,
  trueAnomaly: 0,
  meanAnomaly: 114.2,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const TRITON: CelestialBody = {
  id: 'triton',
  position: {
    x: 0,
    y: 0
  },
  mass: 2139000e15,
  radius: 1352.6,
  semiMajorAxis: 354759,
  eccentricity: 0.0000,
  trueAnomaly: 0,
  meanAnomaly: 264.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const NEREID: CelestialBody = {
  id: 'nereid',
  position: {
    x: 0,
    y: 0
  },
  mass: 2700e15,
  radius: 178.5,
  semiMajorAxis: 5513800,
  eccentricity: 0.7507,
  trueAnomaly: 0,
  meanAnomaly: 359.3,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const HALIMEDE: CelestialBody = {
  id: 'halimede',
  position: {
    x: 0,
    y: 0
  },
  mass: 16e15,
  radius: 31,
  semiMajorAxis: 16681000,
  eccentricity: 0.2909,
  trueAnomaly: 0,
  meanAnomaly: 96.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const SAO: CelestialBody = {
  id: 'sao',
  position: {
    x: 0,
    y: 0
  },
  mass: 6e15,
  radius: 22,
  semiMajorAxis: 22619000,
  eccentricity: 0.2827,
  trueAnomaly: 0,
  meanAnomaly: 129.4,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const LAOMEDEIA: CelestialBody = {
  id: 'laomedeia',
  position: {
    x: 0,
    y: 0
  },
  mass: 5e15,
  radius: 21,
  semiMajorAxis: 23613000,
  eccentricity: 0.4339,
  trueAnomaly: 0,
  meanAnomaly: 321.1,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const PSAMATHE: CelestialBody = {
  id: 'psamathe',
  position: {
    x: 0,
    y: 0
  },
  mass: 4e15,
  radius: 20,
  semiMajorAxis: 46705000,
  eccentricity: 0.4617,
  trueAnomaly: 0,
  meanAnomaly: 206.2,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const NESO: CelestialBody = {
  id: 'neso',
  position: {
    x: 0,
    y: 0
  },
  mass: 15e15,
  radius: 30,
  semiMajorAxis: 50258000,
  eccentricity: 0.4243,
  trueAnomaly: 0,
  meanAnomaly: 269.8,
  type: CelestialBodyType.SATELLITE,
  satellites: [],
  orbitBody: null
};

export const NEPTUNE: CelestialBody = {
  id: 'neptune',
  position: {
    x: 0,
    y: 0
  },
  speed: 5.43,
  mass: 1.02413e26,
  radius: 24622,
  semiMajorAxis: 4495.060e6,
  eccentricity: 0.008678,
  trueAnomaly: 0,
  meanAnomaly: 256.228,
  longitudeOfAscendingNode: 131.783,
  type: CelestialBodyType.PLANET,
  satellites: [
    NAIAD,
    THALASSA,
    DESPINA,
    GALATEA,
    LARISSA,
    HIPPOCAMP,
    PROTEUS,
    TRITON,
    NEREID,
    HALIMEDE,
    SAO,
    LAOMEDEIA,
    PSAMATHE,
    NESO
  ],
  rings: [
    { id: 'galle', radius: 40900, width: 2000, depth: 0.15 },
    { id: 'le_verrier', radius: 53200, width: 113, depth: 0.7 },
    { id: 'lassell', radius: 53200, width: 4000, depth: 0.4 },
    { id: 'adams', radius: 62932, width: 35, depth: 0.4 }
  ],
  orbitBody: null
};

NEPTUNE.satellites.forEach(satellite => satellite.orbitBody = NEPTUNE);
